<template>
  <div class="rounded rounded-t-lg  shadow p-4">
    <div class="flex">
      <div class="w-1/3 mr-1">
        <label class="block text-sm leading-5 font-medium text-gray-700">First Name</label>
        <input aria-label="First Name" name="firstName" type="text" required
               v-model="firstName"
               class="appearance-none rounded-md
                                   relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md
                                    focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 sm:text-sm sm:leading-5"
               placeholder="First Name"/>
      </div>
      <div class="w-1/3 mx-1">
        <label class="block text-sm leading-5 font-medium text-gray-700">Middle Name</label>
        <input aria-label="Last Name" name="lastName" type="text" required
               v-model="middleName"
               class="appearance-none rounded-md
                                   relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md
                                    focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 sm:text-sm sm:leading-5"
               placeholder="Middle Name"/>
      </div>
      <div class="w-1/3 ml-1">
        <label class="block text-sm leading-5 font-medium text-gray-700">Last Name</label>
        <input aria-label="Last Name" name="lastName" type="text" required
               v-model="lastName"
               class="appearance-none rounded-md
                                   relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md
                                    focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 sm:text-sm sm:leading-5"
               placeholder="Last Name"/>
      </div>
    </div>
    <div class="my-3">
      <label class="block text-sm ">Email
        Address</label>
      <input aria-label="Email address" name="email" type="email" required
             v-model="email"
             class="appearance-none rounded-md
                                   relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900
                                    focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 sm:text-sm sm:leading-5"
             placeholder="Email address"/>
    </div>
    <div class="my-3">
      <label class="block text-sm ">Phone Number</label>
      <input aria-label="Phone Number" type="text" required
             v-model="phoneNumber"
             class="appearance-none rounded-md
                                   relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900
                                    focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 sm:text-sm sm:leading-5"
             placeholder="Phone Number"/>
    </div>
    <div class="mt-6">
      <button type="submit" v-on:click="updatePassword" class="rounded px-4 md:px-5 xl:px-4 py-2  bg-teal-500 hover:bg-teal-600 md:text-lg leading-tight
                       xl:text-base text-white">
        Update details
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Account",
  props: {
    userId: String
  },
  data() {
    return {
      errors: [],
      firstName: '',
      middleName: '',
      lastName: '',
      email: '',
      phoneNumber: ''
    }
  },

  watch: {
    errors: function (errors) {
      this.$root.$emit('alert_error', errors);
    }
  },
  mounted() {
    this.axios.get(process.env.VUE_APP_SERVER_URL + '/api/v1/user')
        .then((result) => {
          this.user = result.data.data;
          this.firstName = this.user.first_name;
          this.middleName = this.user.middle_name;
          this.lastName = this.user.last_name;
          this.email = this.user.email;
          this.phoneNumber = this.user.phone_number
        })
        .catch((error) => {
          if (error.response.status === 401)
            this.$router.push("/logout");
        });
  },
  methods: {
    updatePassword: function () {
      this.loading = true;
      this.errors = [];
      this.successes = [];
      if (this.firstName == null || this.firstName === '')
        this.errors.push("First name field is required.");
      if (this.lastName == null || this.lastName === '')
        this.errors.push("Last name field is required.");
      if (this.phoneNumber == null || this.phoneNumber === '')
        this.errors.push("Phone number field is required.");
      if (this.email == null || this.email === '')
        this.errors.push("Email field is required.");
      if (this.errors.length > 0) {
        this.loading = false;
        return;
      }

      this.axios.put(process.env.VUE_APP_SERVER_URL + '/api/v1/profile', {
        first_name: this.firstName,
        middle_name: this.middleName,
        last_name: this.lastName,
        email: this.email,
        phone_number: this.phoneNumber,
      }).then((result) => {
        this.$root.$emit('alert_success', [result.data.message]);
        this.$store.dispatch('refreshUser', result.data.user)
      }).catch((error) => {
        if (error.response != null) {
          if (error.response.status === 422) {
            this.errors.push(error.response.data.error.message);
          } else if (error.response.status === 401)
            this.errors.push(error.response.data.error.message);
        } else
          this.errors.push("An error occurred while connecting to server")
      }).finally(() => {
        this.loading = false;
      });
    }
  }
}
</script>

<style scoped>

</style>